module.exports = __webpack_public_path__ + "static/media/tourism.831aa459.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/tourism.jpg
// module id = 826
// module chunks = 3